import { Tabs } from 'antd'
import React from 'react'
import { browserHistory } from 'react-router'
import { CensusFileRowCountsDto } from '../../api/dto/census-file-row-counts.dto'
import { CensusFileRowTypeEnum } from '../../api/enums/census-file-row-type.enum'
import { CENSUS_REVIEW_PATH } from '../../constants'
import { SAVE_CHANGES_BEFORE_APPROVAL_MESSAGE } from '../constants/census-review.constant'

const { TabPane } = Tabs

interface ReviewTabsProps {
  counts: CensusFileRowCountsDto | undefined
  publicKey: string
  currentTab: string
  onTabChange: (string) => void
  style?: any
  showTabs: boolean
  hasPendingChanges?: boolean
}
const CensusReviewTabs = ({
  showTabs,
  style,
  counts,
  publicKey,
  currentTab,
  onTabChange,
  hasPendingChanges = false,
}: ReviewTabsProps) => {
  const onChange = (key: string) => {
    if (key === currentTab) return

    if (hasPendingChanges) {
      alert(SAVE_CHANGES_BEFORE_APPROVAL_MESSAGE)
      return
    }

    browserHistory.push(`${CENSUS_REVIEW_PATH}/${publicKey}/${key}`)
    onTabChange(key)
  }
  const getCount = (key: string) => {
    return counts?.[key] ?? 0
  }
  if (showTabs === false) {
    return <div style={style}></div>
  }
  return (
    <Tabs
      activeKey={currentTab}
      onChange={onChange}
      type="line"
      tabBarStyle={{
        fontWeight: 'bold',
        fontSize: '16px',
        borderBottom: 'none',
      }}
      style={style}
    >
      <TabPane
        tab={
          <span>
            Errors{' '}
            <span style={{ color: 'black', opacity: 0.4 }}>
              ({getCount(CensusFileRowTypeEnum.ERROR)})
            </span>
          </span>
        }
        key={CensusFileRowTypeEnum.ERROR}
      />
      <TabPane
        tab={
          <span>
            Undetermined{' '}
            <span style={{ color: 'black', opacity: 0.4 }}>
              ({getCount(CensusFileRowTypeEnum.UNDETERMINED)})
            </span>
          </span>
        }
        key={CensusFileRowTypeEnum.UNDETERMINED}
      />
      <TabPane
        tab={
          <span>
            New Records{' '}
            <span style={{ color: 'black', opacity: 0.4 }}>
              ({getCount(CensusFileRowTypeEnum.DRAFT_EMPLOYEE)})
            </span>
          </span>
        }
        key={CensusFileRowTypeEnum.DRAFT_EMPLOYEE}
      />
      <TabPane
        tab={
          <span>
            Updates With Benefits{' '}
            <span style={{ color: 'black', opacity: 0.4 }}>
              ({getCount(CensusFileRowTypeEnum.UPDATE_EMPLOYEE_BENEFITS)})
            </span>
          </span>
        }
        key={CensusFileRowTypeEnum.UPDATE_EMPLOYEE_BENEFITS}
      />
      <TabPane
        tab={
          <span>
            Updates Without Benefits{' '}
            <span style={{ color: 'black', opacity: 0.4 }}>
              ({getCount(CensusFileRowTypeEnum.UPDATE_EMPLOYEE_NO_BENEFITS)})
            </span>
          </span>
        }
        key={CensusFileRowTypeEnum.UPDATE_EMPLOYEE_NO_BENEFITS}
      />
      <TabPane
        tab={
          <span>
            Duplicates{' '}
            <span style={{ color: 'black', opacity: 0.4 }}>
              ({getCount(CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE)})
            </span>
          </span>
        }
        key={CensusFileRowTypeEnum.DUPLICATE_EMPLOYEE}
      />
      <TabPane
        tab={
          <span>
            Activity{' '}
            <span style={{ color: 'black', opacity: 0.4 }}>
              ({getCount('rest')})
            </span>
          </span>
        }
        key={'activity'}
      />
    </Tabs>
  )
}

export default CensusReviewTabs
